import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MikrotikDevicesPageRoutingModule } from './mikrotik-devices-routing.module';
import { MikrotikDevicesPageComponent } from './mikrotik-devices.page';
import { FiltersModule } from 'libs/portal/src/modules/tools/filters/filters.module';
import { CardTableModule } from 'libs/portal/src/modules/tools/card-table/card-table.module';
import { MaterialModule } from '@huge-monorepo/shared/modules';

@NgModule({
  imports: [CommonModule, FormsModule, MikrotikDevicesPageRoutingModule, FiltersModule, CardTableModule, MaterialModule],
  declarations: [MikrotikDevicesPageComponent],
})
export class MikrotikDevicesPageModule {}
